<template>
    <div class="loader loader-tile is-loading" :class="{'is-secondary': secondary}">
        <div class="loading is-loading">
            <div class="mr-re"></div>
            <div class="mr-bil"></div>
            <div class="mr-ly"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'v-inline-loader',
        props: {
            secondary: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>

<docs>
    Default
    ```jsx
    <div class="position-relative inset-l"><v-inline-loader/></div>
    ```
</docs>
